
export default {
  className: 'repair',
  title: '报修订单',
  fields: [
    {
      name: 'user',
      disabled: true,
      searchKey: ['nickName', 'phone'],
      render: (record) => {
        return (record && record.user && record.user.nickName) || ''
      },
      listWhere: (where) => {
        where.isAdmin = {
          $ne: true
        }
      }
    },
    {
      name: 'room',
      disabled: true,
      note: '所属房间'
    },
    {
      disabled: true,
      name: 'details'
    },
    {
      disabled: true,
      name: 'picture'
    },
    {
      name: 'isrepair',
      width: 120,
      note: '是否完成',
      disabled: true
    }
  ],
  search: [
    // 'user',
    {
      name: 'user',
      disabled: false,
      listWhere: (where) => {
        where.isAdmin = {
          $ne: true
        }
        if (!where.phone) {
          where.phone = {
            $exists: true
          }
        }
      }
    },
    'isrepair'
  ],
  hooks: {

  },
  action: {
    create: false,
    // edit: false,
    // delete: false,
    view: false,
    edit: {
      text: '查看'
    },
    complete: {
      type: 'row',
      text: '完成',
      hidden: ({ record }) => {
        return record && record.isrepair
      },
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('警告', '您确定此报修订单已完成了吗？')
        // 更改订单状态
        let cleaning = await vm.$tkParse.put(`/classes/repair/${record.objectId}`, {
          isrepair: true
        })
        if (cleaning) {
          vm.$notification['success']({
            message: '操作成功',
            description: '此订单已完成'
          })
        }
        vm.refresh()
      }
    }
  }
}
